/* Version: 3.5.155 */
'use client';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import useDerivedState from '../../../hooks/useDerivedState.js';
import useId from '../../../hooks/useId.js';

var securitiesIcon = (function (_ref) {
  var alt = _ref.alt,
    controlledId = _ref.id;
  var _useDerivedState = useDerivedState(useId('securities-id-'), controlledId),
    _useDerivedState2 = _slicedToArray(_useDerivedState, 1),
    id = _useDerivedState2[0];
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    focusable: "false",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("path", {
        d: "M0 2.009h5.999v-2H0v2zm0 4h5.999v-2H0v2z"
      })
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsxs("g", {
        fill: "#FFF",
        fillRule: "nonzero",
        children: [/*#__PURE__*/jsx("path", {
          d: "M10.147 11.577a.823.823 0 0 1-.954-.624v-.146h-2.2c0 1.246.77 2.346 1.907 2.786v1.1h2.2v-1.1c.953-.366 1.65-1.21 1.87-2.2a2.804 2.804 0 0 0-.44-2.016 3.3 3.3 0 0 0-2.347-1.284c-.696-.11-.99-.366-.953-.733.073-.33.33-.587.623-.623a.823.823 0 0 1 .954.623v.147h2.2A2.853 2.853 0 0 0 11.1 4.72V3.583H8.9V4.72a2.945 2.945 0 0 0-1.833 2.2c-.11.697.036 1.43.44 2.017a3.3 3.3 0 0 0 2.346 1.283c.697.11.99.367.954.733a.88.88 0 0 1-.66.624z"
        }), /*#__PURE__*/jsx("path", {
          d: "M1.823.283v13.934l8.177 5.5 8.177-5.537V.247H1.823v.036zM15.977 13.08L10 17.077 4.023 13.08V2.483h11.954V13.08z"
        })]
      }), /*#__PURE__*/jsxs("g", {
        transform: "translate(4 5.991)",
        children: [/*#__PURE__*/jsx("mask", {
          id: "".concat(id, "-mask"),
          fill: "#fff"
        }), /*#__PURE__*/jsx("path", {
          fill: "#FFF",
          d: "M-5 10.009h15v-16H-5z",
          mask: "url(#".concat(id, "-mask)")
        })]
      })]
    })]
  });
});

export { securitiesIcon as default };
